<template>
    <table class="table table-hover dynamic-table non-clicker-report-table">
        <thead class="bg-gray-light">
            <tr>
                <th>
                    <sort-by
                        title="ID"
                        :sort="getSort('contacts_list_id')"
                        name="contacts_list_id"
                    />
                </th>
                <th>Contact List</th>
                <th>
                    <sort-by
                        title="Total"
                        :sort="getSort('contacts_count_total')"
                        name="contacts_count_total"
                    />
                </th>
                <th>
                    <sort-by
                        title="Non-Clicker"
                        :sort="getSort('contacts_count_non_clickers')"
                        name="contacts_count_non_clickers"
                    />
                </th>
                <th>
                    <sort-by
                        title="0 Messages"
                        :sort="getSort('messages_0_contacts_count')"
                        name="messages_0_contacts_count"
                    />
                </th>
                <th>
                    <sort-by
                        title="1-3 Messages"
                        :sort="getSort('messages_3_contacts_count')"
                        name="messages_3_contacts_count"
                    />
                </th>
                <th>
                    <sort-by
                        title="4-6 Messages"
                        :sort="getSort('messages_6_contacts_count')"
                        name="messages_6_contacts_count"
                    />
                </th>
                <th>
                    <sort-by
                        title="7-9 Messages"
                        :sort="getSort('messages_9_contacts_count')"
                        name="messages_9_contacts_count"
                    />
                </th>
                <th>
                    <sort-by
                        title="10-15 Messages"
                        :sort="getSort('messages_15_contacts_count')"
                        name="messages_15_contacts_count"
                    />
                </th>
                <th>
                    <sort-by
                        title=">15 Messages"
                        :sort="getSort('more_messages_contacts_count')"
                        name="more_messages_contacts_count"
                    />
                </th>
                <th class="text-right">
                    <sort-by
                        title="Report Date"
                        :sort="getSort('date')"
                        name="date"
                    />
                </th>
            </tr>
        </thead>

        <non-clicker-report-table-row-component
            v-for="(value, idx) in items"
            :key="idx"
            :value="value"
        />

        <tfoot>
            <tr>
                <th :colspan="colspanTotal">Total</th>
                <th>{{ totalItems.contacts_count_total }}</th>
                <th>{{ totalItems.contacts_non_clickers_percent }} ({{ totalItems.contacts_count_non_clickers }})</th>
                <th>{{ totalItems.messages_0_contacts_percent }} ({{ totalItems.messages_0_contacts_count }}) / ({{ totalItems.messages_0_contacts_undelivered_count }})</th>
                <th>{{ totalItems.messages_3_contacts_percent }} ({{ totalItems.messages_3_contacts_count }}) / ({{ totalItems.messages_3_contacts_undelivered_count }})</th>
                <th>{{ totalItems.messages_6_contacts_percent }} ({{ totalItems.messages_6_contacts_count }}) / ({{ totalItems.messages_6_contacts_undelivered_count }})</th>
                <th>{{ totalItems.messages_9_contacts_percent }} ({{ totalItems.messages_9_contacts_count }}) / ({{ totalItems.messages_9_contacts_undelivered_count }})</th>
                <th>{{ totalItems.messages_15_contacts_percent }} ({{ totalItems.messages_15_contacts_count }}) / ({{ totalItems.messages_15_contacts_undelivered_count }})</th>
                <th>{{ totalItems.more_messages_contacts_percent }} ({{ totalItems.more_messages_contacts_count }}) / ({{ totalItems.more_messages_contacts_undelivered_count }})</th>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import EventBus from '../../event-bus';
import SortBy from '../subcomponents/SortBy';
import NonClickerReportTableRowComponent from './NonClickerReportTableRowComponent';

export default {
    filters: {
        capitalize: function (value) {
            if (!value) return '';
            value = value.toString();

            return value.charAt(0).toUpperCase() + value.slice(1);
        },
    },
    components: {
        NonClickerReportTableRowComponent,
        SortBy,
    },
    props: ['report'],
    data: function () {
        return {
            colspanTotal: 2,
            sortDirections: [],
            items: [],
            totalItems: [],
        };
    },
    mounted() {
        this.getReport();
        EventBus.$on('setSort', (data) => {
            this.setSort(data);
        });
    },
    methods: {
        getReport() {
            this.totalItems = this.report.totals;
            this.items = this.report.items;
        },
        setSort(key) {
            let direction = null;
            if (!this.sortDirections[key]) {
                direction = 'desc';
            } else if (this.sortDirections[key] === 'desc') {
                direction = 'asc';
            }
            this.sortDirections = [];
            this.sortDirections[key] = direction;
            this.items = direction ? _.orderBy(this.items, [key], [direction]) : this.items;
        },
        getSort(key) {
            return this.sortDirections[key] ? 'sort-' + this.sortDirections[key] : 'unsorted';
        },
    },
};
</script>

<style scoped>
table > thead > tr > th {
    vertical-align: middle;
}
.table > tbody + tbody {
    border-top: none;
}
</style>
